export default __webpack_public_path__ + "static/ordering.url-ca1652bd1c504a9924ac16385987299d.svg";